import Clearbit from '@clearkit/icons/services/Clearbit';
import Facebook from '@clearkit/icons/services/Facebook';
import G2 from '@clearkit/icons/services/G2';
import Google from '@clearkit/icons/services/Google';
import GoogleAdsIcon from '@clearkit/icons/services/GoogleAds';
import GoogleAnalytics from '@clearkit/icons/services/GoogleAnalytics';
import GoogleTagManager from '@clearkit/icons/services/GoogleTagmanager';
import Hubspot from '@clearkit/icons/services/Hubspot';
import Javascript from '@clearkit/icons/services/Javascript';
import Marketo from '@clearkit/icons/services/Marketo';
import Salesforce from '@clearkit/icons/services/Salesforce';
import Segment from '@clearkit/icons/services/Segment';
import Slack from '@clearkit/icons/services/Slack';

const logos = {
  clearbit: Clearbit,
  facebook: Facebook,
  google: GoogleAnalytics,
  google_ads: GoogleAdsIcon,
  google_conversion: Google,
  google_tag_manager: GoogleTagManager,
  marketo: Marketo,
  hubspot: Hubspot,
  javascript: Javascript,
  salesforce: Salesforce,
  salesforcesandbox: Salesforce,
  pardot: Salesforce,
  segment: Segment,
  slack: Slack,
  g2: G2,
};

export type LogoService = keyof typeof logos;

export type LogoProps = {
  type: LogoService;
  className?: string;
  style?: React.CSSProperties;
};

export default function Logo({ type, ...props }: LogoProps) {
  const Component = logos[type];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}
